// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { HttpClientInstance } from '@toggl/sync/http';
import type { ImagesUpload, Workspace, WorkspacePutOrgId } from '../types';
import { toFormData } from '../utils/requests';

export async function getWorkspace(
  httpClient: HttpClientInstance,
  workspaceId: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(`workspaces/${workspaceId}`, { signal })
    .json<Workspace>();
  return response;
}

export async function uploadImage(
  httpClient: HttpClientInstance,
  workspaceId: number,
  upload: File,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(`workspaces/${workspaceId}/images`, {
      signal,
      body: toFormData({ upload }),
    })
    .json<ImagesUpload>();
  return response;
}

export async function putWorkspaceOrganizationId(
  httpClient: HttpClientInstance,
  workspaceId: number,
  data: WorkspacePutOrgId,
  signal?: AbortSignal
) {
  const response = await httpClient
    .put(`workspaces/${workspaceId}/organizationId`, { signal, json: data })
    .json<Workspace>();
  return response;
}
